//Rainbow.js
import React, { useState } from "react";
import TopBar from "../components/TopBar";
import Menu from "../components/Menu";
import Gallery from "../components/Gallery";

const Rainbow2 = () => {
  const [toggle, setToggle] = useState("menu");
  console.log(toggle, "TOGGLE");
  //   setToggle("gallery");
  let menu = [
    {
      name: "Cold Beverages",
      img: "/rainbow/croped/coldBeverage.png",
      items: [
        {
          "Cold Coffee": 50,
        },
        {
          "Cold Coffee with crush": 70,
        },
        {
          "Cold Coffee with icecream": 80,
        },
        {
          "Cad B": 70,
        },
        {
          "Cad M": 70,
        },
      ],
    },
    {
      name: "Tea",
      img: "/rainbow/croped/tea.png",
      items: [
        {
          Tea: 20,
        },
        {
          "Masala Tea": 30,
        },
        {
          "Lemon Tea": 30,
        },
        {
          "Black Tea": 30,
        },
      ],
    },
    {
      name: "Coffee",
      img: "/rainbow/croped/coffee.png",
      items: [
        {
          "Cold Coffee": 50,
        },
        {
          "Hot Coffee": 40,
        },
        {
          "Black Coffee": 40,
        },
        {
          "Hot Chocolate": 50,
        },
      ],
    },
    {
      name: "Ice Tea",
      img: "/rainbow/croped/iceTea.png",
      items: [
        {
          "Lemon ice Tea": 60,
        },
        {
          "Peach ice Tea": 60,
        },
      ],
    },
    {
      name: "Milkshake",
      img: "/rainbow/croped/Milkshakes.png",
      items: [
        {
          Vanilla: 100,
        },
        {
          Strawberry: 100,
        },
        {
          Chocolate: 100,
        },
        {
          Banana: 100,
        },
        {
          Oreo: 100,
        },
        {
          Kitkat: 100,
        },
        {
          "Dairy Milk ": 100,
        },
      ],
    },
    {
      name: "Mocktail",
      img: "/rainbow/croped/mocktail.png",
      items: [
        {
          Mojito: 100,
        },
        {
          "Blue Lagoon": 100,
        },
        {
          "Black Current": 100,
        },
        {
          "Rainbow Mocktail": 150,
        },
      ],
    },
    {
      name: "Bunmaska",
      img: "/rainbow/croped/bunmaska.png",
      items: [
        {
          Bunmaska: 30,
        },
        {
          "Chocolate Bun Maska": 40,
        },
        {
          "Bread Butter": 30,
        },
        {
          "Bread Butter Toast ": 40,
        },
      ],
    },
    {
      name: "Brownie",
      img: "/rainbow/croped/brownie.png",
      items: [
        {
          "Choclate brownie": 180,
        },
        {
          "Sizzling brownie ": 200,
        },
        {
          "Brownie with ice cream": 250,
        },
      ],
    },
    {
      name: "Pizza",
      img: "/rainbow/croped/pizza.png",
      items: [
        {
          "Margarita pizza": 160,
        },
        {
          "Classic veggie pizza ": 180,
        },
        {
          "Tomato onion cheese pizza": 180,
        },
        {
          "Schezwan paneer pizza": 180,
        },
        {
          "Tandori paneer pizza": 250,
        },
        {
          "Corn cheese pizza": 200,
        },
        {
          "Pahadi pizza": 280,
        },
      ],
    },
    {
      name: "Sandwich",
      img: "/rainbow/croped/sandwich.png",
      items: [
        {
          "Veg sandwich": 60,
        },
        {
          "Veg grill sandwich": 60,
        },
        {
          "Veg cheese grill sandwich": 70,
        },
        {
          "Cheese grill sandwich": 80,
        },
        {
          "Peri peri sandwich": 100,
        },
        {
          "Tandoori Paneer grill sandwich": 120,
        },
        {
          "Corn cheese sandwich": 100,
        },
        {
          "Veg club sandwich": 100,
        },
        {
          "Chocolate sandwich": 100,
        },
        {
          "Garlic cheese chilly sandwich": 120,
        },
        {
          "Triple Layer sandwich": 150,
        },
      ],
    },
    {
      name: "Burger",
      img: "/rainbow/croped/burger.png",
      items: [
        {
          "Aloo tikki burger": 70,
        },
        {
          "Cheese burger": 80,
        },
        {
          "Veg burger": 80,
        },
        {
          "Veg cheese burger": 90,
        },
        {
          "Tandoori burger": 100,
        },
      ],
    },
    {
      name: "Rolls",
      img: "/rainbow/croped/roll.png",
      items: [
        {
          "Cheese roll": 100,
        },
        {
          "Tandoor roll ": 120,
        },
        {
          "Paneer roll": 150,
        },
        {
          "Paneer cheese roll": 170,
        },
      ],
    },
    {
      name: "Bruschetta",
      img: "/rainbow/croped/brushchetta.png",
      items: [
        {
          "Classic bruschetta": 130,
        },
        {
          "Cheese chilly bruschetta ": 140,
        },
      ],
    },
    {
      name: "Maggie",
      img: "/rainbow/croped/maggie.png",
      items: [
        {
          "Masala Maggi": 50,
        },
        {
          "Butter Maggi ": 60,
        },
        {
          "Veg Maggi": 70,
        },
        {
          "Butter Cheese Maggi ": 80,
        },
        {
          "Peri Peri Maggi": 120,
        },
        {
          "Butter Onion Maggi ": 70,
        },
        {
          "Sehezwan Onion Maggi ": 80,
        },
        {
          "Butter Cheese Onion Maggi ": 100,
        },
        {
          "Tandoori Maggi": 120,
        },
      ],
    },
    {
      name: "Pasta",
      img: "/rainbow/croped/pasta.png",
      items: [
        {
          "Vegetable cheese pasta": 150,
        },
        {
          "White sauce pasta ": 150,
        },
        {
          "Red sauce pasta": 150,
        },
        {
          "Pink sauce pasta": 150,
        },
      ],
    },
    {
      name: "Nacho's",
      img: "/rainbow/croped/nachos.png",
      items: [
        {
          "Cheese nacho’s": 120,
        },
        {
          "Tandoor nacho’s ": 120,
        },
        {
          "Garlic chilly nacho’s": 130,
        },
      ],
    },
    {
      name: "Fries",
      img: "/rainbow/croped/Fries.png",
      items: [
        {
          "French fries": 80,
        },
        {
          "Masala fries ": 110,
        },
        {
          "Cheesy fries": 120,
        },
        {
          "Peri peri fries": 100,
        },
        {
          "Tandoori fries ": 140,
        },
        {
          "Mayo fries": 130,
        },
        {
          "Chessy peri peri fries": 140,
        },
      ],
    },
  ];
  console.log(menu);
  return (
    <div>
      <nav id="logo">
        <img
          src={require("../../images/rainbow/croped/final-web-logo.png")}
          alt=""
        ></img>
      </nav>
      <TopBar menu={menu} setToggleFunction={setToggle} toggle={toggle} />

      {toggle === "menu" ? <Menu menu={menu} /> : <Gallery />}
    </div>
  );
};

export default Rainbow2;
